export function ChevronRightIcon({ size = 12, open = false }: { size?: number; open?: boolean } = {}) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} stroke="currentColor" fill="none" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
      style={{ transform: open ? 'rotate(90deg)' : 'none', transition: 'transform .15s' }}>
      <polyline points="9 18 15 12 9 6"/>
    </svg>
  )
}
